import { isEqual } from 'lodash-es';
import { type Dispatch, type SetStateAction, useEffect, useState } from 'react';
import { type ActiveOverviewParams } from '../types.ts';
import { useActiveOverviewDrawerParams } from './useActiveOverviewDrawerParams.ts';

export const useActiveOverviewDrawer = (): [
  ActiveOverviewParams | undefined,
  Dispatch<SetStateAction<ActiveOverviewParams | undefined>>,
] => {
  const [activeOverviewDrawerParams, setActiveOverviewDrawerParams] = useActiveOverviewDrawerParams();

  const [activeOverviewDrawer, setActiveOverviewDrawer] = useState<ActiveOverviewParams | undefined>(
    activeOverviewDrawerParams,
  );

  useEffect(() => {
    if (!isEqual(activeOverviewDrawerParams, activeOverviewDrawer)) {
      setActiveOverviewDrawerParams(activeOverviewDrawer);
    }
    // We only want to rerender when id changes
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [activeOverviewDrawer?.id]);

  useEffect(() => {
    if (!isEqual(activeOverviewDrawerParams, activeOverviewDrawer)) {
      setActiveOverviewDrawer(activeOverviewDrawerParams);
    }
    // We only want to re-execute when id changes
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [activeOverviewDrawerParams?.id]);

  return [activeOverviewDrawer, setActiveOverviewDrawer];
};
